import { render, staticRenderFns } from "./ListReturns.vue?vue&type=template&id=7f1269ea"
import script from "./ListReturns.js?vue&type=script&lang=js&external"
export * from "./ListReturns.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports